import React, { useState } from "react";
import { Card, Form, Badge } from "react-bootstrap";

const PinCombination = (isDark) => {
  const [pin, setPin] = useState("");
  const [copied, setCopied] = useState("");

  const getUniquePermutations = (str) => {
    if (str.length <= 1) return [str];

    const result = new Set();

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const remaining = str.slice(0, i) + str.slice(i + 1);

      for (const perm of getUniquePermutations(remaining)) {
        result.add(char + perm);
      }
    }

    return Array.from(result);
  };

  const permutations =
    pin.length > 0 && pin.length <= 8 ? getUniquePermutations(pin) : [];

  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    setCopied(value);

    setTimeout(() => setCopied(""), 1000);
  };

  return (
    <Card className={`pin-card shadow-sm border ${!isDark && "bg-light"}`}>
      <h5 className="text-center fw-bold mb-3">PIN Combination</h5>

      <Form.Group className="mb-3">
        <Form.Label className="fw-semibold">Enter PIN</Form.Label>
        <Form.Control
          type="text"
          maxLength={8}
          placeholder="e.g. 1111, 121, 1234"
          value={pin}
          className="password-input interactive-input rounded-3"
          style={{ fontSize: 14, padding: "10px" }}
          onChange={(e) => {
            if (/^\d*$/.test(e.target.value)) {
              setPin(e.target.value);
            }
          }}
        />
        <small className="text-muted">Max 8 digits</small>
      </Form.Group>

      {pin.length > 0 && (
        <div className="text-center mb-2">
          <b>Total unique combinations:</b> {permutations.length}
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
          gap: "10px",
          maxHeight: 240,
          overflowY: "auto",
        }}
      >
        {permutations.map((item, index) => (
          <Badge
            title={`Copy ${item}`}
            key={index}
            bg={copied === item ? "success" : "light"}
            text={copied === item ? "light" : "dark"}
            style={{
              cursor: "pointer",
              padding: "10px",
              fontSize: 13,
              borderRadius: 4,
              border: "1px solid #ddd",
              textAlign: "center",
            }}
            onClick={() => copyToClipboard(item)}
          >
            {copied === item ? "Copied!" : item}
          </Badge>
        ))}
      </div>
    </Card>
  );
};

export default PinCombination;
